<template>
    <Heading :labelTitle="title" variant="h3" />
    <CompassTabs v-model="currentTab">
        <CompassTabPane :label="$t.__('common.labels.by_default')" name="default" icon="flag-fill">
            <RichText
                :modelValue="translatableText.value"
                :options="optionsRichText"
                @update:modelValue="updateDefaultValue"
            />
        </CompassTabPane>
        <CompassTabPane
            v-for="language in languages"
            :key="language.id"
            :label="language.lang"
            :name="language.lang"
            :customIcon="getLanguageIcon(language)"
        >
            <RichText
                :modelValue="getTranslationValue(language.id)"
                :options="optionsRichText"
                @update:modelValue="updateTranslationValue(language.id, $event)"
            />
        </CompassTabPane>
    </CompassTabs>
</template>

<script setup lang="ts">
import { getLanguageIcon } from 'Helpers/LanguageHelper';
import RichText from 'vcomponents/richtext/RichText.vue';
import { inject, ref } from 'vue';
import { Language } from 'js/vue/stores/languages/languagesStore';
import type { TranslatableText } from 'types/api/settings/invoicing/invoicingConditionsTypes';
import type { Translator } from 'types/injects/translator.type';
import Heading from 'vcomponents/common/Heading/Heading.vue';
import { useTranslatableText } from 'composables/useTranslatableText';

interface Props {
    languages: Language[];
    title: string;
}
defineProps<Props>();

const translatableText = defineModel<TranslatableText>({
    default: (): TranslatableText => ({ value: '', translations: [] }),
});

const { getTranslationValue, updateTranslationValue, updateDefaultValue } =
    useTranslatableText(translatableText);

const $t = inject('$t') as Translator;

const currentTab = ref<string>('default');

const optionsRichText: string[] = [
    'Bold',
    'Italic',
    'TextAlign',
    'BulletList',
    'CodeBlock',
    'Link',
    'Image',
];
</script>

<style lang="scss" scoped>
:deep(.compass-tabs__container) {
    margin-top: var(--spacing-3);
}
</style>
